
import { defineComponent, ref, computed, onMounted } from "vue";
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Form",
    },
    data: {
      type: Object,
    },
  },
  setup(props) {
    const store = useStore();
    const form = ref(props.data);
   
    const getRTD = () => {
      store.dispatch("Option/getAllRetailDistrictManagers");
    };

    const filterOption = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const all_retail_district_managers = computed(() => store.getters["Option/all_retail_district_managers"]);

    onMounted(getRTD);

    return {
      form,
      all_retail_district_managers,
      filterOption
    };
  },
});
